// If you want to use Phoenix channels, run `mix help phx.gen.channel`
// to get started and then uncomment the line below.
// import "./user_socket.js"

// You can include dependencies in two ways.
//
// The simplest option is to put them in assets/vendor and
// import them using relative paths:
//
//     import "../vendor/some-package.js"
//
// Alternatively, you can `npm install some-package --prefix assets` and import
// them using a path starting with the package name:
//
//     import "some-package"
//

// Include phoenix_html to handle method=PUT/DELETE in forms and buttons.
import "phoenix_html"
// Establish Phoenix Socket and LiveView configuration.
import { Socket } from "phoenix"
import { LiveSocket } from "phoenix_live_view"
import topbar from "../vendor/topbar"
import { userSocket, setupChannel } from "./user_socket"
import Experience from '../src/Experience/Experience';
import ExperienceHook from './hooks/experience_hook';

// Setup LiveSocket
let csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content")
let Hooks = {
  ExperienceHook,
  RangeInput: {
    mounted() {
      const range = this.el.querySelector('[data-role="range"]');
      const number = this.el.querySelector('[data-role="number"]');
      range.addEventListener("input", () => { number.value = range.value; });
      number.addEventListener("input", () => { range.value = number.value; });
    }
  },
  AutoSubmitUpload: {
    mounted() {
      this.el.addEventListener("input", () => {
        // Wait for auto_upload to complete, then submit
        const checkAndSubmit = () => {
          const form = this.el.closest("form");
          if (form) form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        };
        // Small delay to let auto_upload finish
        setTimeout(checkAndSubmit, 200);
      });
    }
  }
};
let liveSocket = new LiveSocket("/live", Socket, {
  longPollFallbackMs: 2500,
  params: { _csrf_token: csrfToken },
  hooks: Hooks
})

// Show progress bar on live navigation and form submits
topbar.config({ barColors: { 0: "#29d" }, shadowColor: "rgba(0, 0, 0, .3)" })
window.addEventListener("phx:page-loading-start", _info => topbar.show(300))
window.addEventListener("phx:page-loading-stop", _info => topbar.hide())

// connect if there are any LiveViews on the page
liveSocket.connect()

// expose liveSocket on window for web console debug logs and latency simulation:
// >> liveSocket.enableDebug()
// >> liveSocket.enableLatencySim(1000)  // enabled for duration of browser session
// >> liveSocket.disableLatencySim()
window.liveSocket = liveSocket

// expose userSocket on window for web console debug logs and latency simulation.
window.userSocket = userSocket;
window.setupChannel = setupChannel;
window.Experience = Experience;

import { initScrollAnimations } from './scroll_animation'
import { initEmailRegistrationCTA } from './email_registration_cta'
import { initProductTilt } from './product_tilt'
import { initProductGallery } from './product_gallery'
import { initScrollExpandSections } from './scroll_expand'
import { initStoreCheckout } from './store_checkout'
import './scroll_timelines/home'

const initializePageScripts = () => {
  initScrollAnimations()
  initEmailRegistrationCTA()
  initProductTilt()
  initProductGallery()
  initScrollExpandSections()
  initStoreCheckout()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializePageScripts)
} else {
  initializePageScripts()
}

